import { Popover, styled } from '@mui/material';

export const OnboardingPopoverStyle = styled(Popover)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiPaper-root': {
    marginTop: theme.spacing(2),
    height: 'auto',
    padding: '16px',
    boxSizing: 'border-box',
    minWidth: '343px',
    borderRadius: '8px',
    boxShadow: '0px 15px 60px 0px rgba(38, 44, 74, 0.20)',
  },
}));
